export default "__VITE_ASSET__6e9aa407__"